import { Formik, Form, Field, ErrorMessage } from "formik";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setStep, setmultiMemberLLCDataStep1 } from "../../../states/legalTools/multiMemberLLCSlice";
import * as Yup from "yup";

const MultiMemberLLCFormStep1Schema = Yup.object().shape({
  submissionUpdatesEmail: Yup.string()
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter a valid email address")
    .required("This field is required"),
  nameOfLLC: Yup.string().required("This field is required"),
  alreadyFiledLLC: Yup.string().required("This field is required"),
  mainBusinessAddressLine1: Yup.string().required("This field is required"),
  mainBusinessCity: Yup.string().required("This field is required"),
  mainBusinessState: Yup.string().required("This field is required"),
  mainBusinessZipCode: Yup.string()
    .min(5, "Please enter valid zipcode")
    .max(5, "Please enter valid zipcode")
    .required("This field is required"),
  primaryBusiness: Yup.string().required("This field is required"),
  noOfMembers: Yup.string().required("This field is required"),
  memberOneFirstName: Yup.string().required("This field is required"),
  memberOneLastName: Yup.string().required("This field is required"),
  memberOneEmail: Yup.string().matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter a valid email address").required("This field is required"),
  memberTwoFirstName: Yup.string().when("noOfMembers", {
    is: (noOfMembers) =>
      noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4",
    then: (schema) => schema.required("This field is required"),
  }),
  memberTwoLastName: Yup.string().when("noOfMembers", {
    is: (noOfMembers) =>
      noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4",
    then: (schema) => schema.required("This field is required"),
  }),
  memberTwoEmail: Yup.string().when("noOfMembers", {
    is: (noOfMembers) =>
      noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4",
    then: (schema) => schema.matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter a valid email address").required("This field is required"),
  }),
  memberThreeFirstName: Yup.string().when("noOfMembers", {
    is: (noOfMembers) => noOfMembers === "3" || noOfMembers === "4",
    then: (schema) => schema.required("This field is required"),
  }),
  memberThreeLastName: Yup.string().when("noOfMembers", {
    is: (noOfMembers) => noOfMembers === "3" || noOfMembers === "4",
    then: (schema) => schema.required("This field is required"),
  }),
  memberThreeEmail: Yup.string().when("noOfMembers", {
    is: (noOfMembers) => noOfMembers === "3" || noOfMembers === "4",
    then: (schema) => schema.matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter a valid email address").required("This field is required"),
  }),
  memberFourFirstName: Yup.string().when("noOfMembers", {
    is: (noOfMembers) => noOfMembers === "4",
    then: (schema) => schema.required("This field is required"),
  }),
  memberFourLastName: Yup.string().when("noOfMembers", {
    is: (noOfMembers) => noOfMembers === "4",
    then: (schema) => schema.required("This field is required"),
  }),
  memberFourEmail: Yup.string().when("noOfMembers", {
    is: (noOfMembers) => noOfMembers === "4",
    then: (schema) => schema.matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Please enter a valid email address").required("This field is required"),
  }),
  ownershipPercentage: Yup.string().required("This field is required"),
  expectToAddNewMembers: Yup.string().required("This field is required"),
  expectationToAddNewMembers: Yup.string().when("expectToAddNewMembers", {
    is: (expectToAddNewMembers) => expectToAddNewMembers === "true",
    then: (schema) => schema.required("This field is required"),
  }),
  memberOneContribution: Yup.array()
    .of(Yup.boolean())
    .test("atLeastOneChecked", "Please select at least one", (value) =>
      value.some((v) => v === true)
    ),
  memberOneOther: Yup.string().when("memberOneContribution", {
    is: (memberOneContribution) => memberOneContribution[4] === true,
    then: (schema) => schema.required("This field is required"),
  }),
  memberOneCashContribution: Yup.number().when("memberOneContribution", {
    is: (memberOneContribution) => memberOneContribution[0] === true,
    then: (schema) =>
      schema
        .typeError("Please enter a valid input")
        .required("This field is required"),
  }),
  memberOnePreExistingIntellectualProperty: Yup.string().when(
    "memberOneContribution",
    {
      is: (memberOneContribution) => memberOneContribution[2] === true,
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberOneOtherAssets: Yup.string().when("memberOneContribution", {
    is: (memberOneContribution) => memberOneContribution[3] === true,
    then: (schema) => schema.required("This field is required"),
  }),
  memberOneIsIntellectualProperty: Yup.string().required(
    "This field is required"
  ),
  memberOneIntellectualProperty: Yup.string().when(
    "memberOneIsIntellectualProperty",
    {
      is: (memberOneIsIntellectualProperty) =>
        memberOneIsIntellectualProperty === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),

  memberTwoContribution: Yup.array().when("noOfMembers", {
    is: (noOfMembers) =>
      (noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4")||true,
    then: (schema) =>
      schema
        .of(Yup.boolean())
        .test("atLeastTwoChecked", "Please select at least one", (value) =>
          value.some((v) => v === true)
        ),
  }),
  memberTwoOther: Yup.string().when(["memberTwoContribution", "noOfMembers"], {
    is: (memberTwoContribution, noOfMembers) =>
      memberTwoContribution[4] === true /* &&
      (noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4") */,
    then: (schema) => schema.required("This field is required"),
  }),
  memberTwoCashContribution: Yup.number().when(
    ["memberTwoContribution", "noOfMembers"],
    {
      is: (memberTwoContribution, noOfMembers) =>
        memberTwoContribution[0] === true /* &&
        (noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4") */,
      then: (schema) =>
        schema
          .typeError("Please enter a valid input")
          .required("This field is required"),
    }
  ),
  memberTwoPreExistingIntellectualProperty: Yup.string().when(
    ["memberTwoContribution", "noOfMembers"],
    {
      is: (memberTwoContribution, noOfMembers) =>
        memberTwoContribution[2] === true /* &&
        (noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4") */,
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberTwoOtherAssets: Yup.string().when(
    ["memberTwoContribution", "noOfMembers"],
    {
      is: (memberTwoContribution, noOfMembers) =>
        memberTwoContribution[3] === true /* &&
        (noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4") */,
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberTwoIsIntellectualProperty: Yup.string().required(
    "This field is required"
  ),
  memberTwoIntellectualProperty: Yup.string().when(
    ["memberTwoIsIntellectualProperty", "noOfMembers"],
    {
      is: (memberTwoIsIntellectualProperty, noOfMembers) =>
        memberTwoIsIntellectualProperty === "true" /* &&
        (noOfMembers === "2" || noOfMembers === "3" || noOfMembers === "4") */,
      then: (schema) => schema.required("This field is required"),
    }
  ),

  memberThreeContribution: Yup.array().when("noOfMembers", {
    is: (noOfMembers) => noOfMembers === "3" || noOfMembers === "4",
    then: (schema) =>
      schema
        .of(Yup.boolean())
        .test("atLeastThreeChecked", "Please select at least one", (value) =>
          value.some((v) => v === true)
        ),
  }),
  memberThreeOther: Yup.string().when(
    ["memberThreeContribution", "noOfMembers"],
    {
      is: (memberThreeContribution, noOfMembers) =>
        memberThreeContribution[4] === true &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberThreeCashContribution: Yup.number().when(
    ["memberThreeContribution", "noOfMembers"],
    {
      is: (memberThreeContribution, noOfMembers) =>
        memberThreeContribution[0] === true &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) =>
        schema
          .typeError("Please enter a valid input")
          .required("This field is required"),
    }
  ),
  memberThreePreExistingIntellectualProperty: Yup.string().when(
    ["memberThreeContribution", "noOfMembers"],
    {
      is: (memberThreeContribution, noOfMembers) =>
        memberThreeContribution[2] === true &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberThreeOtherAssets: Yup.string().when(
    ["memberThreeContribution", "noOfMembers"],
    {
      is: (memberThreeContribution, noOfMembers) =>
        memberThreeContribution[3] === true &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberThreeIsIntellectualProperty: Yup.string().when("noOfMembers",{
    is:(noOfMembers)=>noOfMembers==="4"||noOfMembers==="3",
    then:(schema) => schema.required("This field is required"),
  }),
  memberThreeIntellectualProperty: Yup.string().when(
    ["memberThreeIsIntellectualProperty", "noOfMembers"],
    {
      is: (memberThreeIsIntellectualProperty, noOfMembers) =>
        memberThreeIsIntellectualProperty === "true" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberFourContribution: Yup.array().when("noOfMembers", {
    is: (noOfMembers) => noOfMembers === "3" || noOfMembers === "4",
    then: (schema) =>
      schema
        .of(Yup.boolean())
        .test("atLeastFourChecked", "Please select at least one", (value) =>
          value.some((v) => v === true)
        ),
  }),
  memberFourOther: Yup.string().when(
    ["memberFourContribution", "noOfMembers"],
    {
      is: (memberFourContribution, noOfMembers) =>
        memberFourContribution[4] === true &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberFourCashContribution: Yup.number().when(
    ["memberFourContribution", "noOfMembers"],
    {
      is: (memberFourContribution, noOfMembers) =>
        memberFourContribution[0] === true &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) =>
        schema
          .typeError("Please enter a valid input")
          .required("This field is required"),
    }
  ),
  memberFourPreExistingIntellectualProperty: Yup.string().when(
    ["memberFourContribution", "noOfMembers"],
    {
      is: (memberFourContribution, noOfMembers) =>
        memberFourContribution[2] === true &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberFourOtherAssets: Yup.string().when(
    ["memberFourContribution", "noOfMembers"],
    {
      is: (memberFourContribution, noOfMembers) =>
        memberFourContribution[3] === true &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  memberFourIsIntellectualProperty: Yup.string().when("noOfMembers",{
    is:(noOfMembers)=>noOfMembers==="4",
    then:(schema) => schema.required("This field is required"),
  }),
  memberFourIntellectualProperty: Yup.string().when(
    ["memberFourIsIntellectualProperty", "noOfMembers"],
    {
      is: (memberFourIsIntellectualProperty, noOfMembers) =>
        memberFourIsIntellectualProperty === "true" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  haveOneOrMoreMemberUnitsSubjectToVesting: Yup.string().required(
    "This field is required"
  ),
  membersHaveTheSameVestingSchedule: Yup.string().when(
    "haveOneOrMoreMemberUnitsSubjectToVesting",
    {
      is: (haveOneOrMoreMemberUnitsSubjectToVesting) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  anyMemberHaveSomePortionOfUnitsVestedImmediately: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  portionOfTheMemberUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  percentageOfTheMemberUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "portionOfTheMemberUnitsNotSubjectToVesting",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        portionOfTheMemberUnitsNotSubjectToVesting
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "true" &&
        portionOfTheMemberUnitsNotSubjectToVesting === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherPercentageOfTheMemberUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "portionOfTheMemberUnitsNotSubjectToVesting",
      "percentageOfTheMemberUnitsNotSubjectToVesting",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        portionOfTheMemberUnitsNotSubjectToVesting,
        percentageOfTheMemberUnitsNotSubjectToVesting
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "true" &&
        portionOfTheMemberUnitsNotSubjectToVesting === "true" &&
        percentageOfTheMemberUnitsNotSubjectToVesting === "Other",
      then: (schema) => schema.required("This field is required"),
    }
  ),

  memberOneUnitsVestedImmediately: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "alreadyFiledLLC",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        alreadyFiledLLC,
        anyMemberHaveSomePortionOfUnitsVestedImmediately
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        alreadyFiledLLC === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  percentageOfMemberOneUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "alreadyFiledLLC",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberOneUnitsVestedImmediately",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        alreadyFiledLLC,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberOneUnitsVestedImmediately
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        alreadyFiledLLC === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberOneUnitsVestedImmediately === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherPercentageOfMemberOneUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "alreadyFiledLLC",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberOneUnitsVestedImmediately",
      "percentageOfMemberOneUnitsNotSubjectToVesting",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        alreadyFiledLLC,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberOneUnitsVestedImmediately,
        percentageOfMemberOneUnitsNotSubjectToVesting
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        alreadyFiledLLC === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberOneUnitsVestedImmediately === "true" &&
        percentageOfMemberOneUnitsNotSubjectToVesting === "Other",
      then: (schema) => schema.required("This field is required"),
    }
  ),

  memberTwoUnitsVestedImmediately: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  percentageOfMemberTwoUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberTwoUnitsVestedImmediately",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberTwoUnitsVestedImmediately
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberTwoUnitsVestedImmediately === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherPercentageOfMemberTwoUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberTwoUnitsVestedImmediately",
      "percentageOfMemberTwoUnitsNotSubjectToVesting",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberTwoUnitsVestedImmediately,
        percentageOfMemberTwoUnitsNotSubjectToVesting
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberTwoUnitsVestedImmediately === "true" &&
        percentageOfMemberTwoUnitsNotSubjectToVesting === "Other",
      then: (schema) => schema.required("This field is required"),
    }
  ),

  memberThreeUnitsVestedImmediately: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  percentageOfMemberThreeUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberThreeUnitsVestedImmediately",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberThreeUnitsVestedImmediately,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberThreeUnitsVestedImmediately === "true" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherPercentageOfMemberThreeUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberThreeUnitsVestedImmediately",
      "percentageOfMemberThreeUnitsNotSubjectToVesting",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberThreeUnitsVestedImmediately,
        percentageOfMemberThreeUnitsNotSubjectToVesting,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberThreeUnitsVestedImmediately === "true" &&
        percentageOfMemberThreeUnitsNotSubjectToVesting === "Other" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),

  memberFourUnitsVestedImmediately: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        noOfMembers === "4",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  percentageOfMemberFourUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberFourUnitsVestedImmediately",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberFourUnitsVestedImmediately,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberFourUnitsVestedImmediately === "true" &&
        noOfMembers === "4",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherPercentageOfMemberFourUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberFourUnitsVestedImmediately",
      "percentageOfMemberFourUnitsNotSubjectToVesting",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberFourUnitsVestedImmediately,
        percentageOfMemberFourUnitsNotSubjectToVesting,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberFourUnitsVestedImmediately === "true" &&
        percentageOfMemberFourUnitsNotSubjectToVesting === "Other" &&
        noOfMembers === "4",
      then: (schema) => schema.required("This field is required"),
    }
  ),

  memberThreeUnitsVestedImmediately: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  percentageOfMemberThreeUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberThreeUnitsVestedImmediately",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberThreeUnitsVestedImmediately,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberThreeUnitsVestedImmediately === "true" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherPercentageOfMemberThreeUnitsNotSubjectToVesting: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "anyMemberHaveSomePortionOfUnitsVestedImmediately",
      "memberThreeUnitsVestedImmediately",
      "percentageOfMemberThreeUnitsNotSubjectToVesting",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        anyMemberHaveSomePortionOfUnitsVestedImmediately,
        memberThreeUnitsVestedImmediately,
        percentageOfMemberThreeUnitsNotSubjectToVesting,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        anyMemberHaveSomePortionOfUnitsVestedImmediately === "true" &&
        memberThreeUnitsVestedImmediately === "true" &&
        percentageOfMemberThreeUnitsNotSubjectToVesting === "Other" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  totalVestingTermForEachMember: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherTotalVestingTermForEachMember: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "totalVestingTermForEachMember",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        totalVestingTermForEachMember
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "true" &&
        totalVestingTermForEachMember === "Other",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  totalVestingTermForEachMemberOne: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherTotalVestingTermForEachMemberOne: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "totalVestingTermForEachMemberOne",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        totalVestingTermForEachMemberOne
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        totalVestingTermForEachMemberOne === "Other",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  totalVestingTermForEachMemberTwo: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherTotalVestingTermForEachMemberTwo: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "totalVestingTermForEachMemberTwo",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        totalVestingTermForEachMemberTwo
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        totalVestingTermForEachMemberTwo === "Other",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  totalVestingTermForEachMemberThree: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherTotalVestingTermForEachMemberThree: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "totalVestingTermForEachMemberThree",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        totalVestingTermForEachMemberThree,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        totalVestingTermForEachMemberThree === "Other" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  totalVestingTermForEachMemberFour: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        noOfMembers === "4",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  otherTotalVestingTermForEachMemberFour: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "totalVestingTermForEachMemberFour",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        totalVestingTermForEachMemberFour,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        totalVestingTermForEachMemberFour === "Other" &&
        noOfMembers === "4",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  vestingIncrementForAllMember: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "true",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  vestingIncrementForMemberOne: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  vestingIncrementForMemberTwo: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "totalVestingTermForEachMemberTwo",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        totalVestingTermForEachMemberTwo
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        totalVestingTermForEachMemberTwo !== "No vesting for this member",
      then: (schema) => schema.required("This field is required"),
    }
  ),
  vestingIncrementForMemberThree: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "totalVestingTermForEachMemberThree",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        totalVestingTermForEachMemberThree,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        totalVestingTermForEachMemberThree !== "No vesting for this member" &&
        (noOfMembers === "3" || noOfMembers === "4"),
      then: (schema) => schema.required("This field is required"),
    }
  ),
  vestingIncrementForMemberFour: Yup.string().when(
    [
      "haveOneOrMoreMemberUnitsSubjectToVesting",
      "membersHaveTheSameVestingSchedule",
      "totalVestingTermForEachMemberFour",
      "noOfMembers",
    ],
    {
      is: (
        haveOneOrMoreMemberUnitsSubjectToVesting,
        membersHaveTheSameVestingSchedule,
        totalVestingTermForEachMemberFour,
        noOfMembers
      ) =>
        haveOneOrMoreMemberUnitsSubjectToVesting === "true" &&
        membersHaveTheSameVestingSchedule === "false" &&
        totalVestingTermForEachMemberFour !== "No vesting for this member" &&
        noOfMembers === "4",
      then: (schema) => schema.required("This field is required"),
    }
  ),
});
const MultiMemberLLCFormStep1 = () => {
  const dispatch = useDispatch();
  const multiMemberLLCData = useSelector((state) => state.multiMemberLLC.multiMemberLLCData);
  return (
    <>
      <Formik
        initialValues={{
          submissionUpdatesEmail: multiMemberLLCData.submissionUpdatesEmail,
          nameOfLLC: multiMemberLLCData.nameOfLLC,
          alreadyFiledLLC: multiMemberLLCData.alreadyFiledLLC,
          mainBusinessAddressLine1: multiMemberLLCData.mainBusinessAddressLine1,
          mainBusinessAddressLine2: multiMemberLLCData.mainBusinessAddressLine2,
          mainBusinessCity: multiMemberLLCData.mainBusinessCity,
          mainBusinessState: multiMemberLLCData.mainBusinessState,
          mainBusinessZipCode: multiMemberLLCData.mainBusinessZipCode,
          primaryBusiness: multiMemberLLCData.primaryBusiness,
          noOfMembers: multiMemberLLCData.noOfMembers,
          memberOneFirstName: multiMemberLLCData.memberOneFirstName,
          memberOneInitialName: multiMemberLLCData.memberOneInitialName,
          memberOneLastName: multiMemberLLCData.memberOneLastName,
          memberOneEmail: multiMemberLLCData.memberOneEmail,
          memberTwoFirstName: multiMemberLLCData.memberTwoFirstName,
          memberTwoInitialName: multiMemberLLCData.memberTwoInitialName,
          memberTwoLastName: multiMemberLLCData.memberTwoLastName,
          memberTwoEmail: multiMemberLLCData.memberTwoEmail,
          memberThreeFirstName: multiMemberLLCData.memberThreeFirstName,
          memberThreeInitialName: multiMemberLLCData.memberThreeInitialName,
          memberThreeLastName: multiMemberLLCData.memberThreeLastName,
          memberThreeEmail: multiMemberLLCData.memberThreeEmail,
          memberFourFirstName: multiMemberLLCData.memberFourFirstName,
          memberFourInitialName: multiMemberLLCData.memberFourInitialName,
          memberFourLastName: multiMemberLLCData.memberFourLastName,
          memberFourEmail: multiMemberLLCData.memberFourEmail,
          ownershipPercentage: multiMemberLLCData.ownershipPercentage,
          memberOnePercentage: multiMemberLLCData.memberOnePercentage,
          memberTwoPercentage: multiMemberLLCData.memberTwoPercentage,
          memberThreePercentage: multiMemberLLCData.memberThreePercentage,
          memberFourPercentage: multiMemberLLCData.memberThreePercentage,
          expectToAddNewMembers: multiMemberLLCData.expectToAddNewMembers,
          expectationToAddNewMembers: multiMemberLLCData.expectationToAddNewMembers,
          memberOneContribution: [multiMemberLLCData.memberOneContribution[0], multiMemberLLCData.memberOneContribution[1], multiMemberLLCData.memberOneContribution[2], multiMemberLLCData.memberOneContribution[3], multiMemberLLCData.memberOneContribution[4]],
          /*  memberOneIsCash: multiMemberLLCData.,
          memberOneIsService: multiMemberLLCData.,
          memberOneIsPreExistingIntellectualProperty: multiMemberLLCData.,
          memberOneIsOtherAssets: multiMemberLLCData.,
          memberOneIsOther: multiMemberLLCData., */
          memberOneOther: multiMemberLLCData.memberOneOther,
          memberOneCashContribution: multiMemberLLCData.memberOneCashContribution,
          memberOnePreExistingIntellectualProperty: multiMemberLLCData.memberOnePreExistingIntellectualProperty,
          memberOneOtherAssets: multiMemberLLCData.memberOneOtherAssets,
          memberOneIsIntellectualProperty: multiMemberLLCData.memberOneIsIntellectualProperty,
          memberOneIntellectualProperty: multiMemberLLCData.memberOneIntellectualProperty,

          /*  memberTwoIsCash: multiMemberLLCData.,
          memberTwoIsService: multiMemberLLCData.,
          memberTwoIsPreExistingIntellectualProperty: multiMemberLLCData.,
          memberTwoIsOtherAssets: multiMemberLLCData.,
          memberTwoIsOther: multiMemberLLCData., */
          memberTwoContribution: [multiMemberLLCData.memberTwoContribution[0], multiMemberLLCData.memberTwoContribution[1], multiMemberLLCData.memberTwoContribution[2], multiMemberLLCData.memberTwoContribution[3], multiMemberLLCData.memberTwoContribution[4]],
          memberTwoOther: multiMemberLLCData.memberTwoOther,
          memberTwoCashContribution: multiMemberLLCData.memberTwoCashContribution,
          memberTwoPreExistingIntellectualProperty: multiMemberLLCData.memberTwoPreExistingIntellectualProperty,
          memberTwoOtherAssets: multiMemberLLCData.memberTwoOtherAssets,
          memberTwoIsIntellectualProperty: multiMemberLLCData.memberTwoIsIntellectualProperty,
          memberTwoIntellectualProperty: multiMemberLLCData.memberTwoIntellectualProperty,

          /*  memberThreeIsCash: multiMemberLLCData.,
          memberThreeIsService: multiMemberLLCData.,
          memberThreeIsPreExistingIntellectualProperty: multiMemberLLCData.,
          memberThreeIsOtherAssets: multiMemberLLCData.,
          memberThreeIsOther: multiMemberLLCData., */

          memberThreeContribution: [multiMemberLLCData.memberThreeContribution[0], multiMemberLLCData.memberThreeContribution[1], multiMemberLLCData.memberThreeContribution[2], multiMemberLLCData.memberThreeContribution[3], multiMemberLLCData.memberThreeContribution[4]],
          memberThreeOther: multiMemberLLCData.memberThreeOther,
          memberThreeCashContribution: multiMemberLLCData.memberThreeCashContribution,
          memberThreePreExistingIntellectualProperty: multiMemberLLCData.memberThreePreExistingIntellectualProperty,
          memberThreeOtherAssets: multiMemberLLCData.memberThreeOtherAssets,
          memberThreeIsIntellectualProperty: multiMemberLLCData.memberThreeIsIntellectualProperty,
          memberThreeIntellectualProperty: multiMemberLLCData.memberThreeIntellectualProperty,
          /* 
          memberFourIsCash: multiMemberLLCData.,
          memberFourIsService: multiMemberLLCData.,
          memberFourIsPreExistingIntellectualProperty: multiMemberLLCData.,
          memberFourIsOtherAssets: multiMemberLLCData.,
          memberFourIsOther: multiMemberLLCData., */

          memberFourContribution: [multiMemberLLCData.memberFourContribution[0], multiMemberLLCData.memberFourContribution[1], multiMemberLLCData.memberFourContribution[2], multiMemberLLCData.memberFourContribution[3], multiMemberLLCData.memberFourContribution[4]],
          memberFourOther: multiMemberLLCData.memberFourOther,
          memberFourCashContribution: multiMemberLLCData.memberFourCashContribution,
          memberFourPreExistingIntellectualProperty: multiMemberLLCData.memberFourPreExistingIntellectualProperty,
          memberFourOtherAssets: multiMemberLLCData.memberFourOtherAssets,
          memberFourIsIntellectualProperty: multiMemberLLCData.memberFourIsIntellectualProperty,
          memberFourIntellectualProperty: multiMemberLLCData.memberFourIntellectualProperty,
          haveOneOrMoreMemberUnitsSubjectToVesting: multiMemberLLCData.haveOneOrMoreMemberUnitsSubjectToVesting,
          membersHaveTheSameVestingSchedule: multiMemberLLCData.membersHaveTheSameVestingSchedule,
          anyMemberHaveSomePortionOfUnitsVestedImmediately: multiMemberLLCData.anyMemberHaveSomePortionOfUnitsVestedImmediately,
          portionOfTheMemberUnitsNotSubjectToVesting: multiMemberLLCData.portionOfTheMemberUnitsNotSubjectToVesting,
          percentageOfTheMemberUnitsNotSubjectToVesting: multiMemberLLCData.percentageOfTheMemberUnitsNotSubjectToVesting,
          otherPercentageOfTheMemberUnitsNotSubjectToVesting: multiMemberLLCData.otherPercentageOfTheMemberUnitsNotSubjectToVesting,
          memberOneUnitsVestedImmediately: multiMemberLLCData.memberOneUnitsVestedImmediately,
          percentageOfMemberOneUnitsNotSubjectToVesting: multiMemberLLCData.percentageOfMemberOneUnitsNotSubjectToVesting,
          otherPercentageOfMemberOneUnitsNotSubjectToVesting: multiMemberLLCData.otherPercentageOfMemberOneUnitsNotSubjectToVesting,
          memberTwoUnitsVestedImmediately: multiMemberLLCData.memberTwoUnitsVestedImmediately,
          percentageOfMemberTwoUnitsNotSubjectToVesting: multiMemberLLCData.percentageOfMemberTwoUnitsNotSubjectToVesting,
          otherPercentageOfMemberTwoUnitsNotSubjectToVesting: multiMemberLLCData.otherPercentageOfMemberTwoUnitsNotSubjectToVesting,
          memberThreeUnitsVestedImmediately: multiMemberLLCData.memberThreeUnitsVestedImmediately,
          percentageOfMemberThreeUnitsNotSubjectToVesting: multiMemberLLCData.percentageOfMemberThreeUnitsNotSubjectToVesting,
          otherPercentageOfMemberThreeUnitsNotSubjectToVesting: multiMemberLLCData.otherPercentageOfMemberThreeUnitsNotSubjectToVesting,
          memberFourUnitsVestedImmediately: multiMemberLLCData.memberFourUnitsVestedImmediately,
          percentageOfMemberFourUnitsNotSubjectToVesting: multiMemberLLCData.percentageOfMemberFourUnitsNotSubjectToVesting,
          otherPercentageOfMemberFourUnitsNotSubjectToVesting: multiMemberLLCData.otherPercentageOfMemberFourUnitsNotSubjectToVesting,
          totalVestingTermForEachMember: multiMemberLLCData.totalVestingTermForEachMember,
          otherTotalVestingTermForEachMember: multiMemberLLCData.otherTotalVestingTermForEachMember,
          totalVestingTermForEachMemberOne: multiMemberLLCData.totalVestingTermForEachMemberOne,
          otherTotalVestingTermForEachMemberOne: multiMemberLLCData.otherTotalVestingTermForEachMemberOne,
          totalVestingTermForEachMemberTwo: multiMemberLLCData.totalVestingTermForEachMemberTwo,
          otherTotalVestingTermForEachMemberTwo: multiMemberLLCData.otherTotalVestingTermForEachMemberTwo,
          totalVestingTermForEachMemberThree: multiMemberLLCData.totalVestingTermForEachMemberThree,
          otherTotalVestingTermForEachMemberThree: multiMemberLLCData.otherTotalVestingTermForEachMemberThree,
          totalVestingTermForEachMemberFour: multiMemberLLCData.totalVestingTermForEachMemberFour,
          otherTotalVestingTermForEachMemberFour: multiMemberLLCData.otherTotalVestingTermForEachMemberFour,
          vestingIncrementForAllMember: multiMemberLLCData.vestingIncrementForAllMember,
          vestingIncrementForMemberOne: multiMemberLLCData.vestingIncrementForMemberOne,
          vestingIncrementForMemberTwo: multiMemberLLCData.vestingIncrementForMemberTwo,
          vestingIncrementForMemberThree: multiMemberLLCData.vestingIncrementForMemberThree,
          vestingIncrementForMemberFour: multiMemberLLCData.vestingIncrementForMemberFour,
        }}
        validationSchema={MultiMemberLLCFormStep1Schema}
        onSubmit={(values) => {
          console.log(values);
          window.scrollTo(0, 0);
          dispatch(setStep(2));
          dispatch(setmultiMemberLLCDataStep1(values))
        }}
      >
        {(formik) => (
          <Form>
            <div className="content-box mt-5">
              <h3 className="text-dark content-title">LLC Builder</h3>
              <p>
                This question and answer format tool will help us construct an
                LLC Operating Agreement for your business.{" "}
              </p>
              <p>
                The answers to this form are used to generate an "LLC Term
                Sheet," which summarizes what we believe are the most important
                parts of the agreement between business partners. The LLC Term
                Sheet is a discussion document (not a final binding agreement)
                that helps bridge the gap from the informal general
                understanding between new business partners and a full and final
                LLC Operating Agreement. Term sheets serve a critical function
                in traditional business deals and we believe they are extremely
                valuable for new business partners as well.{" "}
              </p>
              <p>
                This legal tool is still in a work-in-progress and we are always
                looking to make improvements to its functionality and the
                explanatory information to help you make decisions. If you have
                questions or comments, please let us know. You may fill out this
                form as may times as you would like (until we finalize the
                terms). If there is a part that you don't know how best to
                answer, please skip it, or if it is a required entry, put in a
                placeholder answer. We can revisit any open questions and make
                changes.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  Please enter the email address where you would like to receive
                  updates about your submission:<span>*</span>
                </label>
                <Field
                  type="email"
                  name="submissionUpdatesEmail"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="submissionUpdatesEmail"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
            </div>

            <div className="content-box pt-4">
              <h3 className="text-dark content-title">Company Information</h3>
              <div className="mb-3">
                <label className="form-label">
                  What is the name of the LLC:<span>*</span>
                </label>
                <Field type="text" name="nameOfLLC" className="form-control" disabled={multiMemberLLCData.isSubmitted} />
                <ErrorMessage
                  name="nameOfLLC"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Have you already filed to form the LLC?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="alreadyFiledLLC"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="alreadyFiledLLC"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">No</label>
                </div>
                <ErrorMessage
                  name="alreadyFiledLLC"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  What will be the main business address? (Home address is OK,
                  if no separate business address)<span>*</span>
                </label>
                <label className="form-label d-block">Address Line 1</label>
                <Field
                  type="text"
                  name="mainBusinessAddressLine1"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="mainBusinessAddressLine1"
                  component="div"
                  style={{ color: "red" }}
                />
                <label className="form-label">Address Line 2</label>
                <Field
                  type="text"
                  name="mainBusinessAddressLine2"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
              </div>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">City</label>
                  <Field
                    type="text"
                    name="mainBusinessCity"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="mainBusinessCity"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
                <div className="col">
                  <label className="form-label">State</label>
                  <Field
                    type="text"
                    name="mainBusinessState"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="mainBusinessState"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
                <div className="col">
                  <label className="form-label">
                    ZIP code<span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="mainBusinessZipCode"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="mainBusinessZipCode"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label for="exampleFormControlTextarea1" className="form-label">
                  Describe the primary business of the company:
                  <span>*</span>
                </label>
                <Field
                  as="textarea"
                  name="primaryBusiness"
                  rows={3}
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="primaryBusiness"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
            </div>

            <div className="content-box pt-4">
              <h3 className="text-dark content-title">Ownership of the LLC</h3>
              <p>
                <strong>LLC Members:</strong> The owners of an LLC are called
                "members," the equivalent of shareholders in a corporation.
                Members have a variety of other rights, such as the ability to
                vote on certain actions and receive distributions of profits.
                This LLC Builder uses a "member-managed" set-up, with membership
                directly tied to management of the LLC. Each member has the
                right to participate in the day-to-day management of the
                company. There are questions in this form on how to set
                boundaries on each member's right to make decisions.
              </p>

              <p>
                <strong>LLC Units:</strong> Ownership in an LLC is called a
                "membership interest," which is often held in the form of a set
                number of LLC "Units." The LLC Units are the equivalent of
                shares of stock in a corporation. Each member will have a number
                of LLC Units that represent the percentage (%) of their
                ownership in the LLC. For example, if there are two members of
                your LLC, each with 50% ownership, then each member will be
                assigned 5,000 LLC Units. The LLC Builder uses a base of 10,000
                LLC Units. This helps to avoid fractional units.
              </p>

              <div className="mb-3">
                <label className="form-label">
                  How many members does your LLC have?<span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="noOfMembers"
                    className="form-check-input"
                    value="2"
                    disabled={multiMemberLLCData.isSubmitted}
                  />

                  <label className="form-check-label" for="flexRadioDefault1">
                    2
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="noOfMembers"
                    className="form-check-input"
                    value="3"
                    disabled={multiMemberLLCData.isSubmitted}
                  />

                  <label className="form-check-label">3</label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="noOfMembers"
                    className="form-check-input"
                    value="4"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">4</label>
                </div>
                <ErrorMessage
                  name="noOfMembers"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>

              <div className="row mb-3">
                <label className="form-label ps-2">
                  Member One Name<span>*</span>
                </label>
                <div className="col">
                  <label className="form-label">First Name</label>
                  <Field
                    type="text"
                    name="memberOneFirstName"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberOneFirstName"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
                <div className="col">
                  <label className="form-label">Initial {"{optional}"}</label>
                  <Field
                    type="text"
                    name="memberOneInitialName"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                </div>
                <div className="col">
                  <label className="form-label">Last Name</label>
                  <Field
                    type="text"
                    name="memberOneLastName"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberOneLastName"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Member One E-mail Address<span>*</span>
                </label>
                <Field
                  type="text"
                  name="memberOneEmail"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="memberOneEmail"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              {(formik.values.noOfMembers === "2" ||
                formik.values.noOfMembers === "3" ||
                formik.values.noOfMembers === "4") && (
                <>
                  <div className="row mb-3">
                    <label className="form-label ps-2">
                      Member Two Name<span>*</span>
                    </label>
                    <div className="col">
                      <label className="form-label">First Name</label>
                      <Field
                        type="text"
                        name="memberTwoFirstName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <ErrorMessage
                        name="memberTwoFirstName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">
                        Initial {"{optional}"}
                      </label>
                      <Field
                        type="text"
                        name="memberTwoInitialName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Last Name</label>
                      <Field
                        type="text"
                        name="memberTwoLastName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <ErrorMessage
                        name="memberTwoLastName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Member Two E-mail Address<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberTwoEmail"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberTwoEmail"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>
                </>
              )}
              {(formik.values.noOfMembers === "3" ||
                formik.values.noOfMembers === "4") && (
                <>
                  <div className="row mb-3">
                    <label className="form-label ps-2">
                      Member Three Name<span>*</span>
                    </label>
                    <div className="col">
                      <label className="form-label">First Name</label>
                      <Field
                        type="text"
                        name="memberThreeFirstName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <ErrorMessage
                        name="memberThreeFirstName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">
                        Initial {"{optional}"}
                      </label>
                      <Field
                        type="text"
                        name="memberThreeInitialName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Last Name</label>
                      <Field
                        type="text"
                        name="memberThreeLastName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <ErrorMessage
                        name="memberThreeLastName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Member Three E-mail Address<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberThreeEmail"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberThreeEmail"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>
                </>
              )}
              {formik.values.noOfMembers === "4" && (
                <>
                  <div className="row mb-3">
                    <label className="form-label ps-2">
                      Member Four Name<span>*</span>
                    </label>
                    <div className="col">
                      <label className="form-label">First Name</label>
                      <Field
                        type="text"
                        name="memberFourFirstName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <ErrorMessage
                        name="memberFourFirstName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">
                        Initial {"{optional}"}
                      </label>
                      <Field
                        type="text"
                        name="memberFourInitialName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Last Name</label>
                      <Field
                        type="text"
                        name="memberFourLastName"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <ErrorMessage
                        name="memberFourLastName"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Member Four E-mail Address<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberFourEmail"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberFourEmail"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>
                </>
              )}

              <div className="mb-3">
                <label className="form-label">
                  Ownership Percentage<span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="ownershipPercentage"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Ownership percentage will be equally split among the members
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="ownershipPercentage"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Ownership percentage will not be equally split among the
                    members
                  </label>
                </div>
                <ErrorMessage
                  name="ownershipPercentage"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              {formik.values.ownershipPercentage === "false" && (
                <div className="mb-3">
                  <label className="form-label">
                    Member One Ownership Percentage
                  </label>
                  <Field
                    type="text"
                    name="memberOnePercentage"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <span>Please enter the desired ownership percentage</span>
                </div>
              )}
              {formik.values.ownershipPercentage === "false" && (
                <div className="mb-3">
                  <label className="form-label">
                    Member Two Ownership Percentage
                  </label>
                  <Field
                    type="text"
                    name="memberTwoPercentage"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <span>Please enter the desired ownership percentage</span>
                </div>
              )}
              {formik.values.ownershipPercentage === "false" &&
                (formik.values.noOfMembers === "3" ||
                  formik.values.noOfMembers === "4") && (
                  <div className="mb-3">
                    <label className="form-label">
                      Member Three Ownership Percentage
                    </label>
                    <Field
                      type="text"
                      name="memberThreePercentage"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <span>Please enter the desired ownership percentage</span>
                  </div>
                )}
              {formik.values.ownershipPercentage === "false" &&
                formik.values.noOfMembers === "4" && (
                  <div className="mb-3">
                    <label className="form-label">
                      Member Four Ownership Percentage
                    </label>
                    <Field
                      type="text"
                      name="memberFourPercentage"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <span>Please enter the desired ownership percentage</span>
                  </div>
                )}

              <div className="mb-3">
                <label className="form-label">
                  Do you expect to add any new members within the next year?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="expectToAddNewMembers"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />

                  <label className="form-check-label" for="flexRadioDefault1">
                    No
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="expectToAddNewMembers"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <ErrorMessage
                  name="expectToAddNewMembers"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  If not know and there are no current plans to add a new
                  member, enter "no."
                </span>
              </div>
              {formik.values.expectToAddNewMembers === "true" && (
                <div className="mb-3">
                  <label className="form-label">
                    Please briefly explain the expectation to add new member(s):
                    <span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="expectationToAddNewMembers"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="expectationToAddNewMembers"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
            </div>
            <div className="content-box pt-4">
              <p>
                <strong>Member Contributions:</strong> Each member of the LLC
                will be contributing some combination of cash (including
                expenses paid for the company), intellectual property, physical
                assets (equipment), and/or services.
              </p>
              <p>
                <strong>Note:</strong> It is good to reflect some amount of a
                minimum cash contribution to the Company for each member. If you
                have contributed cash, paid expenses, or other items of value,
                and have rough estimates we can use that estimated amount. You
                don't need to be precise at this stage. The information we are
                gathering now is just to get a basic understanding of what each
                member is contribution to the LLC.
              </p>
              <p>
                <strong>Suggestion:</strong> Our default terms will have each
                member contributing all rights to their work product (e.g.
                designs, marketing material, plans, code, etc.) for the company,
                including intellectual property rights in that work. This is to
                ensure that the company owns rights in all of the business
                assets. Even if you don't think of your company as having
                valuable IP, it is important to still have each member
                contribute the IP rights. However, please only mark that the
                member will be contributing "Pre-existing intellectual property"
                or "Other assets" if there are special IP rights or significant
                physical assets (e.g. valuable equipment) being contributed by a
                member. Our default terms will capture everything else.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  What will Member One be contributing to the LLC? (Mark all
                  that apply)<span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberOneContribution[0]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Cash
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberOneContribution[1]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Services</label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberOneContribution[2]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Pre-existing intellectual property (e.g. patents or specific
                    IP, other than general IP created in working on the
                    business)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberOneContribution[3]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Other specific assets (e.g., domain name, personal tangible
                    assets)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberOneContribution[4]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Other </label>
                </div>
                <Field
                  type="text"
                  name="memberOneOther"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="memberOneContribution"
                  component="div"
                  style={{ color: "red" }}
                />
                <ErrorMessage
                  name="memberOneOther"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  We recommend selecting cash for all members (even if only to
                  put a minimal amount) and services for any member that will be
                  active in running the business.
                </span>
              </div>
              {formik.values.memberOneContribution[0] && (
                <div className="mb-3">
                  <label className="form-label">
                    Member One cash contribution<span>*</span>
                  </label>
                  <div className="d-flex align-items-center">
                    <span className="me-2">$</span>
                    <Field
                      type="text"
                      name="memberOneCashContribution"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                  </div>
                  <ErrorMessage
                    name="memberOneCashContribution"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    Estimate if uncertain. We recommend contributing a minimum
                    amount of $0.01 per unit ($1 per 1%) to the company in
                    exchange for your ownership of the company.
                  </span>
                </div>
              )}
              {formik.values.memberOneContribution[2] && (
                <div className="mb-3">
                  <label className="form-label">
                    What pre-existing intellectual property will Member One be
                    contributing?<span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="memberOnePreExistingIntellectualProperty"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />{" "}
                  <ErrorMessage
                    name="memberOnePreExistingIntellectualProperty"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    Our default terms will have all general intellectual
                    property (e.g. business plan, design work, code) that a
                    business partner creates for the business assigned to the
                    LLC. This question is to list IP that was created prior to
                    starting on new business, but that is being brought over and
                    contributed to the new LLC.
                  </span>
                </div>
              )}
              {formik.values.memberOneContribution[3] && (
                <div className="mb-3">
                  <label className="form-label">
                    Briefly describe Member One's other assets being contributed
                    to the company:<span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="memberOneOtherAssets"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberOneOtherAssets"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    E.g., list any domain names, or tangible assets (not
                    including a personal phone or computer)
                  </span>
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">
                  Does Member One have any intellectual property that relates to
                  the business of the company that won't be assigned to it as a
                  contribution?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="memberOneIsIntellectualProperty"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="memberOneIsIntellectualProperty"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">No</label>
                </div>
                <ErrorMessage
                  name="memberOneIsIntellectualProperty"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  E.g., intellectual property of a different, related business
                  or project
                </span>
              </div>
              {formik.values.memberOneIsIntellectualProperty === "true" && (
                <div className="mb-3">
                  <label className="form-label">
                    Briefly describe Member One's unassigned intellectual
                    property:<span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="memberOneIntellectualProperty"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberOneIntellectualProperty"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">
                  What will Member Two be contributing to the LLC? (Mark all
                  that apply)<span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberTwoContribution[0]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Cash
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberTwoContribution[1]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Services</label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberTwoContribution[2]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Pre-existing intellectual property (e.g. patents or specific
                    IP, other than general IP created in working on the
                    business)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberTwoContribution[3]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Other specific assets (e.g., domain name, personal tangible
                    assets)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="memberTwoContribution[4]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Other </label>
                </div>
                <Field
                  type="text"
                  name="memberTwoOther"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="memberTwoOther"
                  component="div"
                  style={{ color: "red" }}
                />
                <ErrorMessage
                  name="memberTwoContribution"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  We recommend selecting cash for all members (even if only to
                  put a minimal amount) and services for any member that will be
                  active in running the business.
                </span>
              </div>
              {formik.values.memberTwoContribution[0] && (
                <div className="mb-3">
                  <label className="form-label">
                    Member Two cash contribution<span>*</span>
                  </label>
                  <div className="d-flex align-items-center">
                    <span className="me-2">$</span>
                    <Field
                      type="text"
                      name="memberTwoCashContribution"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                  </div>
                  <ErrorMessage
                    name="memberTwoCashContribution"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    Estimate if uncertain. We recommend contributing a minimum
                    amount of $0.01 per unit ($1 per 1%) to the company in
                    exchange for your ownership of the company.
                  </span>
                </div>
              )}
              {formik.values.memberTwoContribution[2] && (
                <div className="mb-3">
                  <label className="form-label">
                    What pre-existing intellectual property will Member Two be
                    contributing?<span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="memberTwoPreExistingIntellectualProperty"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberTwoPreExistingIntellectualProperty"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    Our default terms will have all general intellectual
                    property (e.g. business plan, design work, code) that a
                    business partner creates for the business assigned to the
                    LLC. This question is to list IP that was created prior to
                    starting on new business, but that is being brought over and
                    contributed to the new LLC.
                  </span>
                </div>
              )}
              {formik.values.memberTwoContribution[3] && (
                <div className="mb-3">
                  <label className="form-label">
                    Briefly describe Member Two's other assets being contributed
                    to the company:<span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="memberTwoOtherAssets"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberTwoOtherAssets"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    E.g., list any domain names, or tangible assets (not
                    including a personal phone or computer)
                  </span>
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">
                  Does Member Two have any intellectual property that relates to
                  the business of the company that won't be assigned to it as a
                  contribution?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="memberTwoIsIntellectualProperty"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="memberTwoIsIntellectualProperty"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">No</label>
                </div>
                <ErrorMessage
                  name="memberTwoIsIntellectualProperty"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  E.g., intellectual property of a different, related business
                  or project
                </span>
              </div>
              {formik.values.memberTwoIsIntellectualProperty === "true" && (
                <div className="mb-3">
                  <label className="form-label">
                    Briefly describe Member Two's unassigned intellectual
                    property:<span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="memberTwoIntellectualProperty"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberTwoIntellectualProperty"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}

              {(formik.values.noOfMembers === "3" ||
                formik.values.noOfMembers === "4") && (
                <div className="mb-3">
                  <label className="form-label">
                    What will Member Three be contributing to the LLC? (Mark all
                    that apply)<span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberThreeContribution[0]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Cash
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberThreeContribution[1]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">Services</label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberThreeContribution[2]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Pre-existing intellectual property (e.g. patents or
                      specific IP, other than general IP created in working on
                      the business)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberThreeContribution[3]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Other specific assets (e.g., domain name, personal
                      tangible assets)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberThreeContribution[4]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">Other </label>
                  </div>
                  <Field
                    type="text"
                    name="memberThreeOther"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberThreeOther"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <ErrorMessage
                    name="memberThreeContribution"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    We recommend selecting cash for all members (even if only to
                    put a minimal amount) and services for any member that will
                    be active in running the business.
                  </span>
                </div>
              )}
              {(formik.values.noOfMembers === "3" ||
                formik.values.noOfMembers === "4") &&
                formik.values.memberThreeContribution[0] && (
                  <div className="mb-3">
                    <label className="form-label">
                      Member Three cash contribution<span>*</span>
                    </label>
                    <div className="d-flex align-items-center">
                      <span className="me-2">$</span>
                      <Field
                        type="text"
                        name="memberThreeCashContribution"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                    </div>
                    <ErrorMessage
                      name="memberThreeCashContribution"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <span>
                      Estimate if uncertain. We recommend contributing a minimum
                      amount of $0.01 per unit ($1 per 1%) to the company in
                      exchange for your ownership of the company.
                    </span>
                  </div>
                )}
              {(formik.values.noOfMembers === "3" ||
                formik.values.noOfMembers === "4") &&
                formik.values.memberThreeContribution[2] && (
                  <div className="mb-3">
                    <label className="form-label">
                      What pre-existing intellectual property will Member Three
                      be contributing?<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberThreePreExistingIntellectualProperty"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberThreePreExistingIntellectualProperty"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <span>
                      Our default terms will have all general intellectual
                      property (e.g. business plan, design work, code) that a
                      business partner creates for the business assigned to the
                      LLC. This question is to list IP that was created prior to
                      starting on new business, but that is being brought over
                      and contributed to the new LLC.
                    </span>
                  </div>
                )}
              {(formik.values.noOfMembers === "3" ||
                formik.values.noOfMembers === "4") &&
                formik.values.memberThreeContribution[3] && (
                  <div className="mb-3">
                    <label className="form-label">
                      Briefly describe Member Three's other assets being
                      contributed to the company:<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberThreeOtherAssets"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberThreeOtherAssets"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <span>
                      E.g., list any domain names, or tangible assets (not
                      including a personal phone or computer)
                    </span>
                  </div>
                )}
              {(formik.values.noOfMembers === "3" ||
                formik.values.noOfMembers === "4") && (
                <div className="mb-3">
                  <label className="form-label">
                    Does Member Three have any intellectual property that
                    relates to the business of the company that won't be
                    assigned to it as a contribution?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="memberThreeIsIntellectualProperty"
                      className="form-check-input"
                      value="true"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="memberThreeIsIntellectualProperty"
                      className="form-check-input"
                      value="false"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">No</label>
                  </div>
                  <ErrorMessage
                    name="memberThreeIsIntellectualProperty"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    E.g., intellectual property of a different, related business
                    or project
                  </span>
                </div>
              )}
              {(formik.values.noOfMembers === "3" ||
                formik.values.noOfMembers === "4") &&
                formik.values.memberThreeIsIntellectualProperty === "true" && (
                  <div className="mb-3">
                    <label className="form-label">
                      Briefly describe Member Three's unassigned intellectual
                      property:<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberThreeIntellectualProperty"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberThreeIntellectualProperty"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>
                )}

              {formik.values.noOfMembers === "4" && (
                <div className="mb-3">
                  <label className="form-label">
                    What will Member Four be contributing to the LLC? (Mark all
                    that apply)<span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberFourContribution[0]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Cash
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberFourContribution[1]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">Services</label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberFourContribution[2]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Pre-existing intellectual property (e.g. patents or
                      specific IP, other than general IP created in working on
                      the business)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberFourContribution[3]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">
                      Other specific assets (e.g., domain name, personal
                      tangible assets)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="checkbox"
                      name="memberFourContribution[4]"
                      className="form-check-input"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">Other </label>
                  </div>
                  <Field
                    type="text"
                    name="memberFourOther"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="memberFourOther"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <ErrorMessage
                    name="memberFourContribution"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    We recommend selecting cash for all members (even if only to
                    put a minimal amount) and services for any member that will
                    be active in running the business.
                  </span>
                </div>
              )}
              {formik.values.noOfMembers === "4" &&
                formik.values.memberFourContribution[0] && (
                  <div className="mb-3">
                    <label className="form-label">
                      Member Four cash contribution<span>*</span>
                    </label>
                    <div className="d-flex align-items-center">
                      <span className="me-2">$</span>
                      <Field
                        type="text"
                        name="memberFourCashContribution"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                    </div>
                    <ErrorMessage
                      name="memberFourCashContribution"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <span>
                      Estimate if uncertain. We recommend contributing a minimum
                      amount of $0.01 per unit ($1 per 1%) to the company in
                      exchange for your ownership of the company.
                    </span>
                  </div>
                )}
              {formik.values.noOfMembers === "4" &&
                formik.values.memberFourContribution[2] && (
                  <div className="mb-3">
                    <label className="form-label">
                      What pre-existing intellectual property will Member Four
                      be contributing?<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberFourPreExistingIntellectualProperty"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberFourPreExistingIntellectualProperty"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <span>
                      Our default terms will have all general intellectual
                      property (e.g. business plan, design work, code) that a
                      business partner creates for the business assigned to the
                      LLC. This question is to list IP that was created prior to
                      starting on new business, but that is being brought over
                      and contributed to the new LLC.
                    </span>
                  </div>
                )}
              {formik.values.noOfMembers === "4" &&
                formik.values.memberFourContribution[3] && (
                  <div className="mb-3">
                    <label className="form-label">
                      Briefly describe Member Four's other assets being
                      contributed to the company:<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberFourOtherAssets"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberFourOtherAssets"
                      component="div"
                      style={{ color: "red" }}
                    />
                    <span>
                      E.g., list any domain names, or tangible assets (not
                      including a personal phone or computer)
                    </span>
                  </div>
                )}
              {formik.values.noOfMembers === "4" && (
                <div className="mb-3">
                  <label className="form-label">
                    Does Member Four have any intellectual property that relates
                    to the business of the company that won't be assigned to it
                    as a contribution?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="memberFourIsIntellectualProperty"
                      className="form-check-input"
                      value="true"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="memberFourIsIntellectualProperty"
                      className="form-check-input"
                      value="false"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">No</label>
                  </div>
                  <ErrorMessage
                    name="memberFourIsIntellectualProperty"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    E.g., intellectual property of a different, related business
                    or project
                  </span>
                </div>
              )}
              {formik.values.noOfMembers === "4" &&
                formik.values.memberFourIsIntellectualProperty === "true" && (
                  <div className="mb-3">
                    <label className="form-label">
                      Briefly describe Member Four's unassigned intellectual
                      property:<span>*</span>
                    </label>
                    <Field
                      type="text"
                      name="memberFourIntellectualProperty"
                      className="form-control"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <ErrorMessage
                      name="memberFourIntellectualProperty"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>
                )}
            </div>
            <div className="content-box mt-5">
              <h3 className="text-dark content-title">Vesting of Units</h3>
              <p>
                Vesting is a critical part of splitting ownership between
                business partners. Vesting of Units means that a member's Units
                are effectively "earned" over a period of time based on the
                member's continuing work for the company. Each member gets all
                their Units right away, but if a member stops working for the
                business, then the unvested portion (the portion not yet earned)
                is canceled. For example, under a simple vesting schedule, if a
                member’s units vest in monthly increments over a period of 2
                years and that member resigns after 1 year, one-half of the
                member's Units would be vested and the other unvested half would
                be canceled. When one member's unvested Units are cancelled,
                each other member's ownership % increases. Each member’s vesting
                schedule can be different, but often we recommend keeping them
                as uniform as possible to achieve a fair outcome.
              </p>
              <p>
                <strong>Suggestion</strong>: While vesting is not required, we
                think it is one of the more overlooked areas to protect new
                business partners. Vesting is a standard feature in technology
                startups and we believe those same protections are crucial to
                small business partners as well.{" "}
                <strong>
                  Please note that vesting is somewhat complicated. If you
                  aren't already familiar with the idea, then it can be a little
                  hard to understand right away.{" "}
                </strong>
              </p>
              <p>
                <strong>Clarification</strong>: Vesting is different from buying
                out a member when they separate from the business. That is
                addressed below in the section on repurchase rights.
              </p>
              <p>
                <strong>Clarification</strong>: Vesting means that all Units are
                held by the member right away. Units are not granted at the time
                of vesting. Rather, if a member stops working for the company,
                then the unvested Units are cancelled. This distinction is
                important for tax purposes and having it the other way can cause
                tricky complications. This is an often misunderstood part of
                vesting.
              </p>
              <p>
                <strong>
                  Three factors in setting the vesting of Units, which are
                  explained in more detail below:
                  <ol>
                    <li>Initial Portion Not Subject to Vesting</li>
                    <li>Total Vesting Term</li>
                    <li>Vesting Increments </li>
                  </ol>
                </strong>
              </p>
              <p>
                Don't worry, if you don't have a clear idea of what each
                member's vesting should be (or if at all). Enter your best first
                thoughts and we can make changes and help get a vesting schedule
                that makes sense for your situation.
              </p>
            </div>
            <div className="content-box mt-5">
              <div className="mb-3">
                <label className="form-label">
                  Would you like to have one or more member's units subject to
                  vesting?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="haveOneOrMoreMemberUnitsSubjectToVesting"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    No vesting of member's units
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="haveOneOrMoreMemberUnitsSubjectToVesting"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Yes, we would like to have units subject to vesting
                  </label>
                </div>
                <ErrorMessage
                  name="haveOneOrMoreMemberUnitsSubjectToVesting"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              {formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
                "true" && (
                <div className="mb-3">
                  <label className="form-label">
                    Will members have the same vesting schedule?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="membersHaveTheSameVestingSchedule"
                      className="form-check-input"
                      value="true"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="membersHaveTheSameVestingSchedule"
                      className="form-check-input"
                      value="false"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">No</label>
                  </div>
                  <ErrorMessage
                    name="membersHaveTheSameVestingSchedule"
                    component="div"
                    style={{ color: "red" }}
                  />
                </div>
              )}
            </div>
            {formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
              "true" &&
              formik.values.membersHaveTheSameVestingSchedule !== "" && (
                <div className="content-box mt-5">
                  <p>
                    <strong>Portion of Units Vested Immediately</strong> Not all
                    of a member's units have to be subject to vesting. If a
                    member has contributed cash (more than just a minimum
                    startup amount) or other valuable assets, then it can make
                    sense to treat some units as purchased outright and not
                    being earned over time. Also, if a member has already been
                    working on the business for some time then you may want to
                    make some part not subject to vesting to acknowledge that
                    contribution. For example, a member that has been working on
                    the business for a year already before joining up with a new
                    business partner might have 25% of their ownership already
                    vested up front, with the remaining 75% to vest over time
                    (the new business partner's units might still all be subject
                    to vesting).
                  </p>
                  <p>
                    <strong>Suggestion</strong>: If one member has been running
                    the business for years and a new partner is now joining,
                    only the new member's Units would typically be subject to
                    vesting. Please note that there can be tax issues in grant
                    part ownership in an existing business and you should
                    consult with your CPA or tax advisor.
                  </p>
                </div>
              )}

            {formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
              "true" &&
              formik.values.membersHaveTheSameVestingSchedule !== "" && (
                <div className="content-box mt-5">
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Will any member have some portion of units vested
                        immediately?
                        <span>*</span>
                      </label>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="anyMemberHaveSomePortionOfUnitsVestedImmediately"
                          className="form-check-input"
                          value="false"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label" for="flexRadioDefault1">
                          No, all units will be subject to vesting over time
                        </label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="anyMemberHaveSomePortionOfUnitsVestedImmediately"
                          className="form-check-input"
                          value="true"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">
                          Yes, at least one member will have a portion of units
                          vested immediately
                        </label>
                      </div>
                      <ErrorMessage
                        name="anyMemberHaveSomePortionOfUnitsVestedImmediately"
                        component="div"
                        style={{ color: "red" }}
                      />
                      <span>
                        {
                          "(This question is for when you selected members will not have the same vesting schedule. You will be asked questions on the vesting terms for each member.)"
                        }
                      </span>
                    </div>
                  )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "true" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Will a portion of the members' units not be subject to
                        vesting?
                        <span>*</span>
                      </label>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="portionOfTheMemberUnitsNotSubjectToVesting"
                          className="form-check-input"
                          value="false"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label" for="flexRadioDefault1">
                          No, all units will be subject to vesting over time
                        </label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="portionOfTheMemberUnitsNotSubjectToVesting"
                          className="form-check-input"
                          value="true"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">
                          Yes, the members will have a portion of units vested
                          immediately
                        </label>
                      </div>
                      <ErrorMessage
                        name="portionOfTheMemberUnitsNotSubjectToVesting"
                        component="div"
                        style={{ color: "red" }}
                      />
                      <span>
                        {
                          "(This question is for when you selected all members have the same vesting schedule, so it will apply to all members.)"
                        }
                      </span>
                    </div>
                  )}
                  {formik.values.membersHaveTheSameVestingSchedule === "true" &&
                    formik.values.portionOfTheMemberUnitsNotSubjectToVesting ===
                      "true" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What portion (%) of the members' units should not be
                          subject to vesting?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfTheMemberUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="10%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            10%
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfTheMemberUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="25%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">25%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfTheMemberUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="50%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">50%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfTheMemberUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherPercentageOfTheMemberUnitsNotSubjectToVesting"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="otherPercentageOfTheMemberUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="percentageOfTheMemberUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <span>
                          This is the portion that is vested right away and not
                          cancelled if the member stops working for the company.
                        </span>
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.alreadyFiledLLC === "false" &&
                    formik.values
                      .anyMemberHaveSomePortionOfUnitsVestedImmediately ===
                      "true" && (
                      <div className="mb-3">
                        <label className="form-label">
                          Will any of Member One's units be vested immediately
                          (i.e. not subject to vesting)?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="memberOneUnitsVestedImmediately"
                            className="form-check-input"
                            value="false"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            No, all units will be subject to vesting over time
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="memberOneUnitsVestedImmediately"
                            className="form-check-input"
                            value="true"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">
                            Yes, some of Member One's units will be vested
                            immediately
                          </label>
                        </div>
                        <ErrorMessage
                          name="memberOneUnitsVestedImmediately"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.alreadyFiledLLC === "false" &&
                    formik.values
                      .anyMemberHaveSomePortionOfUnitsVestedImmediately &&
                    formik.values.memberOneUnitsVestedImmediately ===
                      "true" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What percentage of Member One's units should not be
                          subject to vesting
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberOneUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="10%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            10%
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberOneUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="25%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">25%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberOneUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="50%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">50%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberOneUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherPercentageOfMemberOneUnitsNotSubjectToVesting"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="percentageOfMemberOneUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="otherPercentageOfMemberOneUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values
                      .anyMemberHaveSomePortionOfUnitsVestedImmediately ===
                      "true" && (
                      <div className="mb-3">
                        <label className="form-label">
                          Will any of Member Two's units be vested immediately
                          (i.e. not subject to vesting)?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="memberTwoUnitsVestedImmediately"
                            className="form-check-input"
                            value="false"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            No, all units will be subject to vesting over time
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="memberTwoUnitsVestedImmediately"
                            className="form-check-input"
                            value="true"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">
                            Yes, some of Member Two's units will be vested
                            immediately
                          </label>
                        </div>
                        <ErrorMessage
                          name="memberTwoUnitsVestedImmediately"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values
                      .anyMemberHaveSomePortionOfUnitsVestedImmediately ===
                      "true" &&
                    formik.values.memberTwoUnitsVestedImmediately ===
                      "true" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What percentage of Member Two's units should not be
                          subject to vesting
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberTwoUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="10%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            10%
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberTwoUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="25%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">25%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberTwoUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="50%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">50%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberTwoUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherPercentageOfMemberTwoUnitsNotSubjectToVesting"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="otherPercentageOfMemberTwoUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="percentageOfMemberTwoUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values
                      .anyMemberHaveSomePortionOfUnitsVestedImmediately ===
                      "true" &&
                    (formik.values.noOfMembers === "3" ||
                      formik.values.noOfMembers === "4") && (
                      <div className="mb-3">
                        <label className="form-label">
                          Will any of Member Three's units be vested immediately
                          (i.e. not subject to vesting)?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="memberThreeUnitsVestedImmediately"
                            className="form-check-input"
                            value="false"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            No, all units will be subject to vesting over time
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="memberThreeUnitsVestedImmediately"
                            className="form-check-input"
                            value="true"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">
                            Yes, some of Member Three's units will be vested
                            immediately
                          </label>
                        </div>
                        <ErrorMessage
                          name="memberThreeUnitsVestedImmediately"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values
                      .anyMemberHaveSomePortionOfUnitsVestedImmediately ===
                      "true" &&
                    formik.values.memberThreeUnitsVestedImmediately ===
                      "true" &&
                    (formik.values.noOfMembers === "3" ||
                      formik.values.noOfMembers === "4") && (
                      <div className="mb-3">
                        <label className="form-label">
                          What percentage of Member Three's units should not be
                          subject to vesting
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberThreeUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="10%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            10%
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberThreeUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="25%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">25%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberThreeUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="50%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">50%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberThreeUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherPercentageOfMemberThreeUnitsNotSubjectToVesting"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="otherPercentageOfMemberThreeUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="percentageOfMemberThreeUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values
                      .anyMemberHaveSomePortionOfUnitsVestedImmediately ===
                      "true" &&
                    formik.values.noOfMembers === "4" && (
                      <div className="mb-3">
                        <label className="form-label">
                          Will any of Member Four's units be vested immediately
                          (i.e. not subject to vesting)?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="memberFourUnitsVestedImmediately"
                            className="form-check-input"
                            value="false"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            No, all units will be subject to vesting over time
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="memberFourUnitsVestedImmediately"
                            className="form-check-input"
                            value="true"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">
                            Yes, some of Member Four's units will be vested
                            immediately
                          </label>
                        </div>
                        <ErrorMessage
                          name="memberFourUnitsVestedImmediately"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values
                      .anyMemberHaveSomePortionOfUnitsVestedImmediately ===
                      "true" &&
                    formik.values.memberFourUnitsVestedImmediately === "true" &&
                    formik.values.noOfMembers === "4" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What percentage of Member Four's units should not be
                          subject to vesting
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberFourUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="10%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            10%
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberFourUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="25%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">25%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberFourUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="50%"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">50%</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="percentageOfMemberFourUnitsNotSubjectToVesting"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherPercentageOfMemberFourUnitsNotSubjectToVesting"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="percentageOfMemberFourUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="otherPercentageOfMemberFourUnitsNotSubjectToVesting"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                </div>
              )}

            {formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
              "true" &&
              formik.values.membersHaveTheSameVestingSchedule !== "" && (
                <div className="content-box mt-5">
                  <p>
                    <strong>Vesting Term.</strong> This is the total time period
                    for all of a member's units to become fully vested. The
                    typical range for a vesting term for units is 2-4 years. The
                    vesting term should be the length of time where you would
                    consider the member to have fully earned their ownership
                    percentage in the company. One way to think about it is to
                    ask yourself the question: When would it be OK for my
                    business partner to resign and still hold their full
                    ownership percentage of the business? Remember the buy-out
                    right of a departing member for vested Units is a different
                    provision that is addressed below.
                  </p>
                  <p>
                    The LLC Builder only supports time-based vesting. If other
                    vesting criteria our desired, please complete the form
                    assuming there would be only time-based vesting and schedule
                    a call with us to discuss other vesting provisions.
                  </p>
                </div>
              )}

            {formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
              "true" &&
              formik.values.membersHaveTheSameVestingSchedule !== "" && (
                <div className="content-box mt-5">
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "true" && (
                    <div className="mb-3">
                      <label className="form-label">
                        What should be the total vesting term for each member?
                        <span>*</span>
                      </label>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="totalVestingTermForEachMember"
                          className="form-check-input"
                          value="Four years"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label" for="flexRadioDefault1">
                          Four years
                        </label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="totalVestingTermForEachMember"
                          className="form-check-input"
                          value="Three years"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">Three years</label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="totalVestingTermForEachMember"
                          className="form-check-input"
                          value="Two years"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">Two years</label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="totalVestingTermForEachMember"
                          className="form-check-input"
                          value="One years"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">One years</label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="totalVestingTermForEachMember"
                          className="form-check-input"
                          value="Other"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">Other</label>
                      </div>
                      <Field
                        type="text"
                        name="otherTotalVestingTermForEachMember"
                        className="form-control"
                        disabled={multiMemberLLCData.isSubmitted}
                      />
                      <ErrorMessage
                        name="totalVestingTermForEachMember"
                        component="div"
                        style={{ color: "red" }}
                      />
                      <ErrorMessage
                        name="otherTotalVestingTermForEachMember"
                        component="div"
                        style={{ color: "red" }}
                      />
                      <span>
                        {
                          "(This question is for when you selected all members have the same vesting schedule, so it will apply to all members.)"
                        }
                      </span>
                    </div>
                  )}

                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
                      "true" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What should be the the total length of the vesting
                          term for Member One?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberOne"
                            className="form-check-input"
                            value="Four years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            Four years
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberOne"
                            className="form-check-input"
                            value="Three years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Three years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberOne"
                            className="form-check-input"
                            value="Two years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Two years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberOne"
                            className="form-check-input"
                            value="One years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">One years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberOne"
                            className="form-check-input"
                            value="No vesting for this member"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">
                            No vesting for this member
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberOne"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherTotalVestingTermForEachMemberOne"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="totalVestingTermForEachMemberOne"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="otherTotalVestingTermForEachMemberOne"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <span>
                          {
                            "(This question is for when you selected all members have the same vesting schedule, so it will apply to all members.)"
                          }
                        </span>
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
                      "true" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What should be the the total length of the vesting
                          term for Member Two?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberTwo"
                            className="form-check-input"
                            value="Four years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            Four years
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberTwo"
                            className="form-check-input"
                            value="Three years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Three years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberTwo"
                            className="form-check-input"
                            value="Two years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Two years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberTwo"
                            className="form-check-input"
                            value="One years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">One years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberTwo"
                            className="form-check-input"
                            value="No vesting for this member"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">
                            No vesting for this member
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberTwo"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherTotalVestingTermForEachMemberTwo"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="totalVestingTermForEachMemberTwo"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="otherTotalVestingTermForEachMemberTwo"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <span>
                          {
                            "(This question is for when you selected all members have the same vesting schedule, so it will apply to all members.)"
                          }
                        </span>
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
                      "true" &&
                    (formik.values.noOfMembers === "3" ||
                      formik.values.noOfMembers === "4") && (
                      <div className="mb-3">
                        <label className="form-label">
                          What should be the the total length of the vesting
                          term for Member Three?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberThree"
                            className="form-check-input"
                            value="Four years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            Four years
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberThree"
                            className="form-check-input"
                            value="Three years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Three years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberThree"
                            className="form-check-input"
                            value="Two years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Two years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberThree"
                            className="form-check-input"
                            value="One years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">One years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberThree"
                            className="form-check-input"
                            value="No vesting for this member"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">
                            No vesting for this member
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberThree"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherTotalVestingTermForEachMemberThree"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="totalVestingTermForEachMemberThree"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="otherTotalVestingTermForEachMemberThree"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <span>
                          {
                            "(This question is for when you selected all members have the same vesting schedule, so it will apply to all members.)"
                          }
                        </span>
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
                      "true" &&
                    formik.values.noOfMembers === "4" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What should be the the total length of the vesting
                          term for Member Four?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberFour"
                            className="form-check-input"
                            value="Four years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            Four years
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberFour"
                            className="form-check-input"
                            value="Three years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Three years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberFour"
                            className="form-check-input"
                            value="Two years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Two years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberFour"
                            className="form-check-input"
                            value="One years"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">One years</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberFour"
                            className="form-check-input"
                            value="No vesting for this member"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">
                            No vesting for this member
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="totalVestingTermForEachMemberFour"
                            className="form-check-input"
                            value="Other"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Other</label>
                        </div>
                        <Field
                          type="text"
                          name="otherTotalVestingTermForEachMemberFour"
                          className="form-control"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <ErrorMessage
                          name="totalVestingTermForEachMemberFour"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name="otherTotalVestingTermForEachMemberFour"
                          component="div"
                          style={{ color: "red" }}
                        />
                        <span>
                          {
                            "(This question is for when you selected all members have the same vesting schedule, so it will apply to all members.)"
                          }
                        </span>
                      </div>
                    )}
                </div>
              )}

            {formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
              "true" &&
              formik.values.membersHaveTheSameVestingSchedule !== "" && (
                <div className="content-box mt-5">
                  <p>
                    <strong>Vesting Increments:</strong> Should the unvested
                    Units vest monthly, quarterly, or annually? Generally, the
                    less frequent the vesting the more importance is placed on
                    each vesting date. This can create incentives for people to
                    try to time any departure or termination around vesting. For
                    this reason, we feel that monthly vesting offers the
                    smoothest vesting schedule and is good for business partners
                    with roughly equal working commitments. Annual vesting
                    should be considered carefully if it is appropriate for the
                    circumstances.
                  </p>
                </div>
              )}

            {formik.values.haveOneOrMoreMemberUnitsSubjectToVesting ===
              "true" &&
              formik.values.membersHaveTheSameVestingSchedule !== "" && (
                <div className="content-box mt-5">
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "true" && (
                    <div className="mb-3">
                      <label className="form-label">
                        What will be the vesting increment for all members?
                        <span>*</span>
                      </label>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="vestingIncrementForAllMember"
                          className="form-check-input"
                          value="Monthly"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label" for="flexRadioDefault1">
                          Monthly
                        </label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="vestingIncrementForAllMember"
                          className="form-check-input"
                          value="Quarterly"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">Quarterly</label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="vestingIncrementForAllMember"
                          className="form-check-input"
                          value="Annually"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">Annually</label>
                      </div>
                      <ErrorMessage
                        name="vestingIncrementForAllMember"
                        component="div"
                        style={{ color: "red" }}
                      />
                      <span>
                        {
                          "(This question is for when you selected all members have the same vesting schedule, so it will apply to all members.)"
                        }
                      </span>
                    </div>
                  )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" && (
                    <div className="mb-3">
                      <label className="form-label">
                        What will be the vesting increment for Member One's
                        Units?
                        <span>*</span>
                      </label>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="vestingIncrementForMemberOne"
                          className="form-check-input"
                          value="Monthly"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label" for="flexRadioDefault1">
                          Monthly
                        </label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="vestingIncrementForMemberOne"
                          className="form-check-input"
                          value="Quarterly"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">Quarterly</label>
                      </div>
                      <div className="form-check">
                        <Field
                          type="radio"
                          name="vestingIncrementForMemberOne"
                          className="form-check-input"
                          value="Annually"
                          disabled={multiMemberLLCData.isSubmitted}
                        />
                        <label className="form-check-label">Annually</label>
                      </div>
                      <ErrorMessage
                        name="vestingIncrementForMemberOne"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                  )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.totalVestingTermForEachMemberTwo !==
                      "No vesting for this member" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What will be the vesting increment for Member Two's
                          Units?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberTwo"
                            className="form-check-input"
                            value="Monthly"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            Monthly
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberTwo"
                            className="form-check-input"
                            value="Quarterly"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Quarterly</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberTwo"
                            className="form-check-input"
                            value="Annually"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Annually</label>
                        </div>
                        <ErrorMessage
                          name="vestingIncrementForMemberTwo"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.totalVestingTermForEachMemberThree !==
                      "No vesting for this member" &&
                    (formik.values.noOfMembers === "3" ||
                      formik.values.noOfMembers === "4") && (
                      <div className="mb-3">
                        <label className="form-label">
                          What will be the vesting increment for Member Three's
                          Units?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberThree"
                            className="form-check-input"
                            value="Monthly"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            Monthly
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberThree"
                            className="form-check-input"
                            value="Quarterly"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Quarterly</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberThree"
                            className="form-check-input"
                            value="Annually"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Annually</label>
                        </div>
                        <ErrorMessage
                          name="vestingIncrementForMemberThree"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                  {formik.values.membersHaveTheSameVestingSchedule ===
                    "false" &&
                    formik.values.totalVestingTermForEachMemberThree !==
                      "No vesting for this member" &&
                    formik.values.noOfMembers === "4" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What will be the vesting increment for Member Four's
                          Units?
                          <span>*</span>
                        </label>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberFour"
                            className="form-check-input"
                            value="Monthly"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label
                            className="form-check-label"
                            for="flexRadioDefault1"
                          >
                            Monthly
                          </label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberFour"
                            className="form-check-input"
                            value="Quarterly"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Quarterly</label>
                        </div>
                        <div className="form-check">
                          <Field
                            type="radio"
                            name="vestingIncrementForMemberFour"
                            className="form-check-input"
                            value="Annually"
                            disabled={multiMemberLLCData.isSubmitted}
                          />
                          <label className="form-check-label">Annually</label>
                        </div>
                        <ErrorMessage
                          name="vestingIncrementForMemberFour"
                          component="div"
                          style={{ color: "red" }}
                        />
                      </div>
                    )}
                </div>
              )}

            <div className="d-flex justify-content-end">
              {/*  <button className="btn-submit-secondary me-2 rounded pe-3 d-flex align-items-center">
                <i className="fa-solid fa-arrow-left mx-2"></i>Prevoius
              </button> */}
              <button
                type="submit"
                className="submit-button ps-3 d-flex align-items-center"
                onClick={()=>{console.log(formik)}}
              >
                NEXT<i className="ms-2 fa-solid fa-arrow-right "></i>
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default MultiMemberLLCFormStep1;
